/**
 * Helper for formatting a ISO 8601 date. Supported date-parts for formatting are:
 * - d: two-digit day of the month.
 * - m: two-digit month of the year.
 * - Y: four-digit year.
 * - H: two-digit 24-hour style hour of the day
 * - i: two-digit minute of the hour
 * - s: two-digit second of the minute
 *
 * @param {string} iso8601 ISO 8601 date to format
 * @param {object} options Helper options
 * @param {string} [options.format] Format to use; defaults to "d.m.Y"
 * @returns {string} Formatted date
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default function (iso8601: string, options: any): string {
  let format = 'd.m.Y';
  if (options.hash.hasOwnProperty('format')) {
    format = options.hash.format;
  }

  const date = new Date(iso8601);

  if (format.indexOf('d') !== -1) {
    format = format.replace('d', date.getDate().toString().padStart(2, '0'));
  }

  if (format.indexOf('m') !== -1) {
    format = format.replace('m', (date.getMonth() + 1).toString().padStart(2, '0'));
  }

  if (format.indexOf('Y') !== -1) {
    format = format.replace('Y', date.getFullYear().toString());
  }

  if (format.indexOf('H') !== -1) {
    format = format.replace('H', date.getHours().toString().padStart(2, '0'));
  }

  if (format.indexOf('i') !== -1) {
    format = format.replace('i', date.getMinutes().toString().padStart(2, '0'));
  }

  if (format.indexOf('s') !== -1) {
    format = format.replace('s', date.getSeconds().toString().padStart(2, '0'));
  }

  return format;
}
